<app-processing [visible]="!pageVars.isReady"></app-processing>

<p-breadcrumb [model]="pageVars.breadcrumbItems">
  <ng-template let-item let-last="last" let-first="first" pTemplate="item">
    <ng-container *ngIf="!first">
      <a *ngIf="item.routerLink" [routerLink]="item.routerLink">{{ item.label }}</a>
      <div *ngIf="!item.routerLink" class="breadcrumb-current-item">{{ item.label }}</div>
    </ng-container>
  </ng-template>
</p-breadcrumb>

<div class="flex justify-content-between w-100 mb-3 mt-2">
  <div class="flex align-items-center">
    <p-button pTooltip="Reset Table" tooltipPosition="top" icon="pi pi-refresh" [raised]="true" class="mr-2" (click)="resetPage(dt)"></p-button>
    <p-button
      pTooltip="Clear Filter/Sort"
      tooltipPosition="top"
      *ngIf="filtersActive"
      icon="pi pi-filter-slash"
      [raised]="true"
      (click)="clearFilters(dt)"></p-button>
  </div>
  <div class="flex align-items-center">
    <button pButton pRipple [raised]="true" class="mr-2" label="Provide Feedback" [disabled]="selectedInstances.length === 0" (click)="dlgShow()"></button>
    <button pButton pRipple [raised]="true" class="mr-2" label="Export List" (click)="export()"></button>
  </div>
</div>

<ng-container>
  <p-table
    #dt
    [value]="instances"
    [columns]="cols"
    [reorderableColumns]="true"
    [resizableColumns]="true"
    columnResizeMode="expand"
    [paginator]="true"
    [first]="skip"
    [rows]="take"
    [totalRecords]="totalCount"
    [filterDelay]="300"
    [lazy]="true"
    [scrollable]="true"
    scrollHeight="60vh"
    stateKey="receive-order-table"
    stateStorage="local"
    (onLazyLoad)="handleTableEvents($event)">

    <ng-template #header let-columns>
      <tr>
        <th style="width: 3rem">
          <p-checkbox inputId="selectAll" [binary]="true" [ngModel]="selectAllToggle" (click)="toggleSelectAll(!selectAllToggle)"></p-checkbox>
        </th>
        <th
          *ngFor="let col of columns"
          pResizableColumn
          pReorderableColumn
          [pSortableColumn]="col.field"
          [ngStyle]="getColumnHeaderStyle(col.field)">
          {{ col.header }}
          <p-sortIcon [field]="col.field"></p-sortIcon>
          <p-columnFilter
            [type]="col.type"
            [field]="col.field"
            placeholder="Filter.."
            display="menu"
            class="ml-1"
            [matchModeOptions]="col.type === 'text' ? customMatchModeOptions : col.type === 'date' ? dateMatchModeOptions : col.type === 'numeric' ? numericMatchModeOptions : undefined">
          </p-columnFilter>
        </th>
      </tr>
    </ng-template>

    <ng-template #body let-instance let-columns="columns">
      <tr>
        <td>
          <p-checkbox
            inputId="selectRows"
            name="selectRows"
            [value]="instance.InstanceId"
            [(ngModel)]="selectedInstances"
            (onChange)="selectRowClick()"></p-checkbox>
        </td>
        <td *ngFor="let col of columns" [ngStyle]="col.style">
          <ng-container [ngSwitch]="col.template">
            <a *ngSwitchCase="'link'" [routerLink]="['/orders', instance.OrderId, 'receive']">
              {{ instance[col.field] }}
            </a>
            <div *ngSwitchCase="'tooltip'" [pTooltip]="instance[col.field]" tooltipPosition="top" class="text-line-clamp-3" style="overflow: hidden">
              {{ instance[col.field] }}
            </div>
            <ng-container *ngSwitchDefault>
              {{ instance[col.field] }}
            </ng-container>
          </ng-container>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="cols.length + 1">No orders found.</td>
      </tr>
    </ng-template>
  </p-table>
</ng-container>

<p-dialog
  [(visible)]="dlgVars.isVisible"
  header="Feedback"
  [modal]="'true'"
  [position]="'center'"
  [closeOnEscape]="false"
  [closable]="false"
  [style]="{ 'width': '20rem' }">
  <div class="flex-col">
    <div *ngFor="let item of feedback; let idx = index">
      <div *ngIf="item.question.category === 'Primary' || dlgVars.expanded" class="mb-2">
        <div style="font-size: 0.8rem; font-weight: bolder">{{ item.question.text }}</div>
        <div *ngIf="item.question.type === 'Rating'" class="flex justify-content-start">
          <p-rating [(ngModel)]="item.answer.answerText" [stars]="item.question.options.length" (ngModelChange)="onFeedbackAnswerChange()"></p-rating>
        </div>
        <div *ngIf="item.question.type === 'Text'" class="flex justify-content-start">
          <textarea rows="5" cols="30" pTextarea [(ngModel)]="item.answer.answerText" (ngModelChange)="onFeedbackAnswerChange()"></textarea>
        </div>
        <div *ngIf="item.question.type === 'Choice'" class="flex-col justify-content-start">
          <div *ngFor="let option of item.question.options" class="flex justify-content-start mb-1">
            <p-radiobutton
              attr.inputId="radioButton{{ idx }}"
              attr.name="radioButton{{ idx }}"
              size="small"
              [value]="option.text"
              [(ngModel)]="item.answer.answerText"
              (ngModelChange)="onFeedbackAnswerChange()"></p-radiobutton>
            <label attr.for="radioButton{{ idx }}" style="font-size: 0.8rem; margin-left: 0.25rem; margin-top: 0.25rem">{{ option.text }}</label>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="!dlgVars.expanded">
      <p-button label="Provide More Feedback" [link]="true" (click)="dlgVars.expanded = true"></p-button>
    </div>
  </div>
  <ng-template #footer>
    <div class="border-top-1 surface-border flex justify-content-between pt-2 w-full">
      <p-button label="Cancel" icon="fa fa-times" severity="danger" size="small" [raised]="true" (click)="dlgCancel()" />
      <p-button
        label="Save"
        icon="fa fa-check"
        severity="success"
        size="small"
        [raised]="true"
        (click)="dlgSave()"
        [disabled]="!isFeedbackDialogValid" />
    </div>
  </ng-template>
</p-dialog>